import SubcontractRequestDeliveryDetail from '@/models/SubcontractRequestDelivery/SubcontractRequestDeliveryDetail';

export default class SubcontractRequestDeliveryDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.subcontractRequestDeliveryId  = '';
		this.subcontractRequestDeliveryRequestDeliveryNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.poQtyOutstanding = '';
		this.stockVendor = '';
		this.deliveryQty = '';
		this.uom = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			subcontractRequestDeliveryId : '0',
			subcontractRequestDeliveryRequestDeliveryNumber : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			poQtyOutstanding : '0',
			stockVendor : '0',
			deliveryQty : '0',
			uom : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}